<script setup lang="ts">
import CoreIcon from '@core/core-icon.vue';
import { computed } from 'vue';

const props = defineProps({
	icon: {
		type: Object,
		default: null
	},
	bordered: {
		type: Boolean,
		default: false
	},
	rounded: {
		type: Boolean,
		default: false
	},
	pink: {
		type: Boolean,
		default: false
	},
	red: {
		type: Boolean,
		default: false
	},
});
const modes = computed(() => ({
	'part-label_bordered': props.bordered,
	'part-label_pink': props.pink,
	'part-label_rounded': props.rounded,
	'part-label_red': props.red,
}));
</script>

<template>
	<div :class="['part-label', modes]">
		<core-icon
			v-if="icon && icon?.name"
			:name="icon.name"
			:viewBox="icon?.viewBox || '0 0 14 14'"
			class="part-label__icon"
		>
		</core-icon>
		<span class="part-label__text">
			<slot />
		</span>
	</div>
</template>
<style lang="scss">
.part-label {
	width: fit-content;
	padding: 0.8rem 1.1rem;
	// background: rgba(255, 255, 255, 0.09);
	border-radius: 1.2rem;
	fill: currentColor;
	// color: #fff;
	display: flex;
	gap: 1.6rem;
	align-items: center;

	@include min-desktop {
		padding: 1.2rem 1.6rem;
		@include font-18-pro-medium;
	}

	&_bordered {
		background-color: transparent;
		border: 1px solid rgba(255, 255, 255, 0.21);
	}

	&_rounded {
		border-radius: 100rem;
	}

	&_pink {
		color: var(--color-active);
		background: rgba(var(--color-active-rgb), 0.12);
		border: 1px solid rgba(var(--color-active-rgb), 0.12);
		@include theme-dark {
			border-color: rgba(var(--color-active-rgb), 0.04);
		}
	}

	&_red {
		background: linear-gradient(145.85deg, rgba(255, 44, 88, 0.12) -18.66%, rgba(238, 143, 103, 0.12) 109.59%), #FFFFFF;
		border: 1px solid rgba(255, 44, 88, 0.12);
		color: var(--color-orange);
		@include theme-dark {
			color: #FFAD9B;
			border-color: rgba(255, 255, 255, 0.04);
			background: linear-gradient(145.85deg, rgba(255, 44, 88, 0.12) -18.66%, rgba(238, 143, 103, 0.12) 109.59%), rgba(255, 255, 255, 0.12);
		}
	}

	&__icon {
		width: 1.6rem;
		@include min-desktop {
			width: 1.8rem;
		}
	}
	&__text {
		line-height: 1.2;
	}
}
</style>
